import React from "react";
import { ClipLoader } from "react-spinners";
import { Stack } from "@mui/material";

type Props = {
  isLoading?: boolean;
};

const Spinner = ({ isLoading = true }: Props) => {
  return (
    <>
      <Stack
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        className="my-32"
      >
        <ClipLoader
          color="#191B1E"
          size={35}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Stack>
    </>
  );
};

export default Spinner;
